import React from "react";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import CloseIcon from "@mui/icons-material/Close";
import {
  DrawerHeader,
  Drawer as MUIDrawer,
  drawerWidth,
} from "./style";
import CustomRouterLink from "./CustomRouterLink";
import { useSelector, useDispatch } from "react-redux";
import menuIcons from "../../constants/menuIcons";
import { useTranslation } from "react-i18next";
import { Box, IconButton, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import { clearCredentials } from "../../store/slices/authSlice";
import { useNavigate } from "react-router-dom";
import CollapsibleMenu from "./CollapsiMenu";
import { useMessageBadgeCount, isMessagesMenuRoute } from "../../hooks/useMessageBadgeCount";
import { appColors } from "../../constants/theme";

const Drawer = ({ open, isMobile, handleDrawerClose }) => {
  const { items, isLoaded } = useSelector((state) => state.menu);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const uiDisabled = useSelector(state => state.app.uiDisabled);
  const { badgeCount: messageBadgeCount } = useMessageBadgeCount();

  const handleLogout = () => {
    dispatch(clearCredentials());
    navigate("/login");
  };

  const handleNavClick = () => {
    if (isMobile) {
      handleDrawerClose?.();
    }
  };

  if (!isLoaded) return <></>;

  const drawerContent = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <DrawerHeader
        sx={{
          backgroundColor: appColors.primary,
          display: "flex",
          alignItems: "center",
          justifyContent: isMobile ? "space-between" : "center",
          flexShrink: 0,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, width: isMobile ? "auto" : "100%" }}>
          <Box
            sx={{
              width: 48,
              height: 48,
              backgroundColor: "white",
              borderRadius: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "24px",
              fontWeight: "bold",
              color: appColors.primary,
            }}
          >
            M
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
            <Box
              sx={{
                fontSize: "1.25rem",
                color: "white",
                fontWeight: 700,
                lineHeight: 1.2,
              }}
            >
              Medilya
            </Box>
            <Box
              sx={{
                fontSize: "0.875rem",
                color: "rgba(255, 255, 255, 0.9)",
                fontWeight: 500,
                lineHeight: 1.2,
              }}
            >
              Uzman Paneli
            </Box>
          </Box>
        </Box>
        {isMobile && (
          <IconButton onClick={handleDrawerClose} sx={{ color: "white" }} aria-label="Menüyü kapat">
            <CloseIcon />
          </IconButton>
        )}
      </DrawerHeader>
      <Divider sx={{ flexShrink: 0 }} />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minHeight: 0,
          overflow: "hidden",
        }}
      >
        <List
          sx={{
            pointerEvents: uiDisabled ? "none" : "auto",
            opacity: uiDisabled ? 0.5 : 1,
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            overflowX: "hidden",
            py: 0,
          }}
        >
          <CustomRouterLink key={0} to="/home" text={t("home")} onClick={handleNavClick}>
            {menuIcons["HomeIcon"]}
          </CustomRouterLink>
          {items.map((item, index) => {
            if (item.children && item.children.length > 0) {
              return (
                <CollapsibleMenu
                  key={`menu-${item.id || item.text}-${index}`}
                  item={item}
                  t={t}
                  onNavigate={handleNavClick}
                />
              );
            }
            return (
              <CustomRouterLink
                key={`menu-${item.id || item.text}-${index}`}
                to={item.to}
                text={t(item.text)}
                badgeCount={isMessagesMenuRoute(item.to) ? messageBadgeCount : undefined}
                onClick={handleNavClick}
              >
                {menuIcons[item.icon]}
              </CustomRouterLink>
            );
          })}
        </List>

        <Box sx={{ flexShrink: 0, padding: "8px" }}>
          <Divider sx={{ marginBottom: "8px" }} />
          <ListItem disablePadding>
            <ListItemButton
              onClick={() => {
                handleNavClick();
                handleLogout();
              }}
              sx={{
                borderRadius: "8px",
                margin: "4px 8px",
                transition: "background-color 0.15s ease",
                "&:hover": {
                  backgroundColor: "rgba(244, 67, 54, 0.1)",
                },
              }}
            >
              <ListItemIcon sx={{ color: appColors.error }}>
                <ExitToAppIcon />
              </ListItemIcon>
              <ListItemText
                secondary={t("logout")}
                sx={{
                  "& .MuiListItemText-secondary": {
                    color: appColors.error,
                    fontSize: "0.95rem",
                    fontWeight: 500,
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
        </Box>
      </Box>
    </Box>
  );

  if (isMobile) {
    return (
      <MuiDrawer
        variant="temporary"
        open={open}
        onClose={handleDrawerClose}
        ModalProps={{ keepMounted: true }}
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 2,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        {drawerContent}
      </MuiDrawer>
    );
  }

  return (
    <MUIDrawer variant="permanent" open={open}>
      {drawerContent}
    </MUIDrawer>
  );
};

export default Drawer;
